import type { Collection } from 'state/utils/types';
import { SecondaryMarketPostEventTabType } from 'state/workspaces/model';
import {
  BcsProductKey,
  SecondaryMarketLoadingStatus,
} from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';

export type SecondaryMarketPostEventState = Readonly<{
  tabType: SecondaryMarketPostEventTabType;
  orderId: string;
  bcsProductKey?: BcsProductKey;
  reloadOrderStatus?: SecondaryMarketLoadingStatus;
  reloadFormStatus?: SecondaryMarketLoadingStatus;
}>;

export type SecondaryMarketPostEventStateMap = Collection<SecondaryMarketPostEventState>;

export const initialSecondaryMarketPostEventState: SecondaryMarketPostEventStateMap = {};
